import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { History } from 'history';
import { startListening } from '../utils/customRouter';
import { useStore } from 'react-redux';

interface CustomRouterProps {
  history: History;
  children: React.ReactNode;
}

const CustomRouter: React.FC<CustomRouterProps> = ({ history, children }) => {
  const store = useStore();
  
  useEffect(() => {
    // Start listening to history changes and dispatch to store
    const unlisten = startListening(history, store);
    
    // Clean up when component unmounts
    return unlisten;
  }, [history, store]);

  return (
    <Router history={history}>
      {children}
    </Router>
  );
};

export default CustomRouter;